import { Set } from "immutable";

import { Feature } from "@sol/features";
import { Route } from "@sol/routing";

const NATIVE_ADMIN_ROUTE_ACCESS: Partial<Record<Route, Feature[]>> = {
    [Route.ADMIN_PAGES]: [Feature.ADMIN_PAGES_MANAGE],
    [Route.ADMIN_PAGES_CREATE]: [Feature.ADMIN_PAGES_MANAGE],
    [Route.ADMIN_PAGES_DETAILS]: [Feature.ADMIN_PAGES_MANAGE],
    [Route.ADMIN_PAGES_EDIT]: [Feature.ADMIN_PAGES_MANAGE],
    [Route.ADMIN_ANNOUNCEMENTS]: [Feature.ADMIN_ANNOUNCEMENTS_MANAGE],
    [Route.ADMIN_ANNOUNCEMENTS_CREATE]: [Feature.ADMIN_ANNOUNCEMENTS_MANAGE],
    [Route.ADMIN_ANNOUNCEMENTS_DETAILS]: [Feature.ADMIN_ANNOUNCEMENTS_MANAGE],
    [Route.ADMIN_ANNOUNCEMENTS_EDIT]: [Feature.ADMIN_ANNOUNCEMENTS_MANAGE],
    [Route.ADMIN_BRIEFS]: [Feature.BRIEFS_ADMIN],
    [Route.ADMIN_BRIEFS_DETAILS]: [Feature.BRIEFS_ADMIN],
    [Route.ADMIN_FRAMEWORKS]: [Feature.FRAMEWORKS_ADMIN_READ],
    [Route.ADMIN_FRAMEWORKS_DETAILS]: [Feature.FRAMEWORKS_ADMIN_READ],
    [Route.ADMIN_FRAMEWORKS_CREATE]: [Feature.FRAMEWORKS_ADMIN_WRITE],
    [Route.ADMIN_SKILLS]: [Feature.SKILLS_ADMIN_READ],
    [Route.ADMIN_SKILLS_DETAILS]: [Feature.SKILLS_ADMIN_READ],
    [Route.ADMIN_SKILL_DOMAINS]: [Feature.SKILL_DOMAINS_ADMIN_READ],
    [Route.ADMIN_SKILL_DOMAINS_DETAILS]: [Feature.SKILL_DOMAINS_ADMIN_READ],
    [Route.ADMIN_SKILL_BLOCKS]: [Feature.SKILL_BLOCKS_ADMIN_READ],
    [Route.ADMIN_SKILL_BLOCKS_DETAILS]: [Feature.SKILL_BLOCKS_ADMIN_READ],
    [Route.LANGUAGES]: [Feature.LANGUAGES_VIEW],
    [Route.LANGUAGES_CREATE]: [Feature.LANGUAGES_MANAGE],
    [Route.LANGUAGES_DETAILS]: [Feature.LANGUAGES_VIEW],
    [Route.LANGUAGES_EDIT]: [Feature.LANGUAGES_MANAGE],
    [Route.TAGS]: [Feature.TAGS_VIEW],
    [Route.TAGS_CREATE]: [Feature.TAGS_MANAGE],
    [Route.TAGS_DETAILS]: [Feature.TAGS_VIEW],
    [Route.TAGS_EDIT]: [Feature.TAGS_MANAGE],
    [Route.CATEGORIES]: [Feature.CATEGORIES_VIEW],
    [Route.CATEGORIES_CREATE]: [Feature.CATEGORIES_MANAGE],
    [Route.CATEGORIES_DETAILS]: [Feature.CATEGORIES_VIEW],
    [Route.CATEGORIES_EDIT]: [Feature.CATEGORIES_MANAGE],
    [Route.STATISTICS]: [Feature.ADMIN_STATISTICS],
    [Route.CERTIFICATION_ISSUERS]: [Feature.CERTIFICATION_ISSUERS_MANAGE],
    [Route.CERTIFICATION_ISSUERS_CREATE]: [Feature.CERTIFICATION_ISSUERS_MANAGE],
    [Route.CERTIFICATION_ISSUERS_DETAILS]: [Feature.CERTIFICATION_ISSUERS_MANAGE],
    [Route.CERTIFICATION_ISSUERS_EDIT]: [Feature.CERTIFICATION_ISSUERS_MANAGE],
    [Route.TRAINING_TEMPLATES]: [Feature.TRAINING_TEMPLATES_MANAGE],
    [Route.TRAINING_TEMPLATES_CREATE]: [Feature.TRAINING_TEMPLATES_MANAGE],
    [Route.TRAINING_TEMPLATES_EDIT]: [Feature.TRAINING_TEMPLATES_MANAGE],
};

export const resolveNativeAdminRouteAccess = (
    route: Route,
    features: Set<Feature>,
): "not-native" | "allowed" | "forbidden" => {
    const requiredFeatures = NATIVE_ADMIN_ROUTE_ACCESS[route];
    if (!requiredFeatures) {
        return "not-native";
    }

    return requiredFeatures.some(feature => features.has(feature)) ? "allowed" : "forbidden";
};

export const isNativeAdminRoute = (route: Route): boolean => NATIVE_ADMIN_ROUTE_ACCESS[route] !== undefined;
